import clsx from "clsx";
import { memo } from "react";
import { useTranslation } from "react-i18next";

import classes from "../../styles.module.scss";

import { Icon } from "@components/atoms/icons";
import { Typography } from "@components/atoms/typography";
import type { ITableHeadingProps } from "@components/organisms/pageTable";
import { HeaderTabGroup } from "@components/molecules/headerTabGroup";
import { IconButton } from "@components/molecules/iconButton";

export const TableHeading = memo(function TableHeading({
  title,
  tabProps,
  onDownload,
  onPrint,
  icon,
}: ITableHeadingProps) {
  const { t } = useTranslation("common");

  return (
    <>
      <div className={clsx(classes.pageTable__heading)}>
        {
          <>
            <div
              className={clsx(
                classes.pageTable__row,
                classes.pageTable__headPadding,
              )}
            >
              <div className={clsx(classes.pageTable__headingTitle)}>
                <Icon
                  name={icon || "List"}
                  type={"bold-duotone"}
                  color={"primary-main"}
                  fontSize={"2xl"}
                />
                <Typography
                  variant={"body"}
                  color={"primary-text"}
                  fontWeight={"semi-bold"}
                  fontFamily={"Morabba"}
                >
                  {title}
                </Typography>
              </div>
              <div className={clsx(classes.pageTable__headIconButtons)}>
                <IconButton
                  icon={<Icon name={"PrinterMinimalistic"} />}
                  label={t("print")}
                  transparent
                  onClick={onPrint}
                  className={clsx(!onPrint && classes.pageTable__hidden)}
                />
                <IconButton
                  icon={<Icon name={"DownloadSquare"} />}
                  label={t("download")}
                  transparent
                  onClick={onDownload}
                  className={clsx(!onDownload && classes.pageTable__hidden)}
                />
              </div>
            </div>
            {tabProps && (
              <HeaderTabGroup
                tabs={tabProps.tabs}
                onChange={tabProps.onChange}
                selectedKey={tabProps.selectedKey}
              />
            )}
          </>
        }
      </div>
    </>
  );
});
